import React, { createContext, useContext, useState } from 'react';

// Create the context
const PaymentExpendedContext = createContext(undefined);

const PaymentExpendedProvider = ({ children }) => {
  const [paymentExpanded, setPaymentExpanded] = useState(false);

  return (
    <PaymentExpendedContext.Provider value={[paymentExpanded, setPaymentExpanded]}>
      {children}
    </PaymentExpendedContext.Provider>
  );
};

const usePaymentExpended = () => {
  const context = useContext(PaymentExpendedContext);
  if (context === undefined) {
    throw new Error('usePaymentExpended must be used within a PaymentExpendedProvider');
  }
  return context;
};

export { PaymentExpendedProvider, usePaymentExpended };
